import React, { useState } from "react";
import "./PredefinedImages.css";

const imageCategories = {
  // "TV Panels": ["/images/tvpanel.png"],
  "Sofas": ["/images/sofafornt-removebg-preview.png",
    "/images/lsofafront1.png",
    "/images/lsofafront (2).png",
    "/images/lsofafront (3).png",
    "/images/lsofafront.png",
    "/images/lsofafront (5).png",
    "/images/lsofafront (6).png",
    "/images/lsofafront (7).png",
  ],
  "Center Tables": ["/images/centertable.png"],
  "Lamps": ["/images/LAMP.png"],
};

const PredefinedImages = ({ addImageToCanvas }) => {
  const [selectedCategory, setSelectedCategory] = useState("");

  return (
    <div className="predefined-images">
      <h3>Predefined Images</h3>
      <select onChange={(e) => setSelectedCategory(e.target.value)}>
        <option value="">Select a Category</option>
        {Object.keys(imageCategories).map((category) => (
          <option key={category} value={category}>{category}</option>
        ))}
      </select>

      {selectedCategory && (
        <div className="predefined-images-list">
          {imageCategories[selectedCategory].map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${selectedCategory} ${index + 1}`}
              onClick={() => {
                const image = new window.Image();
                image.src = img;
                image.onload = () => addImageToCanvas(image);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PredefinedImages;
